import React, { useLayoutEffect, useRef, useState } from "react";
import Footer from "../Footer/Footer";
import Axios from "axios";
import "./Gallery.css";
import studentInfo from "./studentInfo"
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";

const importAll = (r) => {
  return r.keys().map(r);
};

function SubAccordionItem({
  title,
  Images,
  accrdNum,
}) {
  return (
    <>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#accrd` + accrdNum} aria-expanded="false" aria-controls={`accrd` + accrdNum}>
            {title}
          </button>
        </h2>
        <div id={`accrd` + accrdNum} class="accordion-collapse collapse" data-bs-parent="#imageGallery">
          <div class="accordion-body">
            <div className="row container">
              {Images.map((image, index) => (
                <div className="col-lg-4" key={index}>
                  <img
                    src={image}
                    alt={image}
                    className="accordianImage object-cover w-full h-full rounded-lg"
                  />
                  <a className="accordian-image-download" href={image} download={image}>Download</a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


function Gallery() {
  const url = "https://hgs.mediapattern.com/";
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState({});
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isUserDataAvailable, userDataSet] = useState(false);
  const [UserDatas, setUserData] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  let UserData;

  function getUserData(e) {
    let userData;
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://eschool.appsosindia.org/views/api/std_tc_list.php?school_code=HGSF',
      headers: {
        'Authorization': 'Vksmpy001AAsos',
      },
    };

    Axios.request(config)
      .then((response) => {
        userData = JSON.stringify(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    return userData;
  }

  function findStudent(data, name, tcNo) {
    const searchName = name.trim().toLowerCase();
    const searchTcNo = tcNo.trim();

    return data.student_tcinfo.find(
      (student) =>
        student.STD_NAME &&
        student.STD_NAME.trim().toLowerCase() === searchName &&
        student.STD_TCNO &&
        student.STD_TCNO.trim() === searchTcNo
    );
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    let UserData;
    if (!isUserDataAvailable) {
      // UserData = await getUserData();
      UserData = JSON.stringify(studentInfo);
      await setUserData(UserData)
      userDataSet(true)
    } else {
      UserData = UserDatas
    }

    console.log(UserData)

    let sercheinfo = findStudent(JSON.parse(UserData), username, password);
    if (typeof sercheinfo != 'undefined') {
      setIsAuthenticated(true);
      setError("");

    } else {
      setError("Invalid student name or Tc");
    }
  };

  const toggleMain = (id) => {
    setOpenMain((prev) => (prev === id ? null : id));
    setOpenSub({});
  };

  const toggleSub = (mainId, subId) => {
    setOpenSub((prev) => ({
      ...prev,
      [mainId]: prev[mainId] === subId ? null : subId,
    }));
  };

  const earlry = importAll(
    require.context(
      "../../image/new-gallery/event-folder",
      false,
      /\.(png|jpe?g|svg|jfif|JPE?G)|webp$/
    )
  );

  return (
    <div className="home_main" onScroll={handleScroll}>
      <Navbar isScrolled={true} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <div className="contactus_main">
        {(!isAuthenticated) ? (<>
          <div className="row">
            <form
              onSubmit={handleLogin}
              className="col-lg-5 mx-auto"
            >
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Student full name</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">Tc No</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  required
                />
              </div>
              {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
              <button
                type="submit"
                className="w-full py-2 rounded btn-success"
              >
                Login
              </button>
            </form>
          </div>
        </>) : null}

        {(isAuthenticated) ? (<>
          <div className="bg-gray-100 p-6">
            <div class="accordion accrdimagegaller" id="imageGallery">
              <SubAccordionItem title="Event Name" Images={earlry} accrdNum="1" />
            </div>
          </div>
        </>) : null}
      </div>

      <Footer />
    </div>
  );
}

export default Gallery;
